import { AppCompaniesChoices } from "src/types"

export type Socials = "Сайт" | "Телеграм" | "ВКонтакте"

type ICompanyInfo = {
    [key in keyof typeof AppCompaniesChoices]: {
        description: string,
        socials: Record<Socials, string>,
        fontColor: string,
        isP: boolean
        isS: boolean
    }
}

export const companyInfo: ICompanyInfo = {
    [AppCompaniesChoices["alfa-bank"]]: {
        description: "Альфа-Банк — крупнейший частный банк России и лучший работодатель по версии hh.ru. Наша команда — это эксперты, которые внедряют инновации, заботятся о клиентах и поддерживают друг друга. Мы открываем коворкинги и IT-кластеры для сотрудников в разных городах, приглашаем студентов на стажировки и постоянно учимся новому в Альфа-Академии.",
        socials: {
            "Сайт": "https://job.alfabank.ru/",
            "Телеграм": "https://t.me/alfadigital_jobs",
            "ВКонтакте": ""
        },
        fontColor: "white",
        isP: false,
        isS: false
    },
    [AppCompaniesChoices["vsk"]]: {
        description: "ВСК — страховая компания в топ-5 на рынке России. Нашими услугами пользуются более 30 млн человек, поэтому за качество сервисов отвечает большая команда — 7000 сотрудников в 500 офисах по всей стране. Мы заботимся о том, чтобы всем было комфортно работать — каждый год составляем план развития, ежеквартально встречаемся на PI-планировании, проводим митапы и хакатоны, ездим отдыхать в турцентр и работать в коворкинг в Сочи.",
        socials: {
            Сайт: "",
            "Телеграм": "https://t.me/vsk_hr",
            "ВКонтакте": "https://vk.com/vskhr"
        },
        fontColor: "white",
        isP: false,
        isS: false
    },
    [AppCompaniesChoices["h"]]:  {
        description: "Эйч — сервис развития карьеры. Каждый месяц более тысячи профессионалов растут с нами в навыках, позициях и доходе. За 5 лет мы помогли 50 000 специалистам определиться с карьерным треком, используя опыт 400+ менторов из ведущих мировых и российских компаний.",
        socials: {
            "Сайт": "https://h.careers/?utm_source=site_ar&utm_medium=new_year",
            "Телеграм": "https://t.me/+C8cCIjIKUT4yYzJi",
            "ВКонтакте": ""
        },
        fontColor: "white",
        isP: false,
        isS: false
    },
    [AppCompaniesChoices["sport-master"]]: {
        description: "Спортмастер — первая цифровая спортивная платформа в России. Мы делаем спорт доступным для миллионов людей и знаем всё про well-being. Поэтому работаем соответствующе: ценим work-life balance, любим ставить профессиональные рекорды, участвуем в соревнованиях и заботимся о команде.",
        socials: {
            "Сайт": "",
            "Телеграм": "https://t.me/sportmaster_digital",
            "ВКонтакте": ""
        },
        fontColor: "white",
        isP: true,
        isS: false
    },
    [AppCompaniesChoices["vtb"]]: {
        description: "ВТБ — банк, услугами которого пользуются более 23 миллионов частных клиентов и свыше миллиона компаний разной величины. Мы создаём условия для профессионального развития сотрудников и помогаем начинающим специалистам сделать первые шаги в карьере. Для этого мы запускаем стажировки и спецпроекты, проводим кейс-чемпионаты и образовательные курсы для студентов, организуем дни открытых дверей и другие крутые ивенты.",
        socials: {
            "Сайт": "",
            "Телеграм": "https://t.me/vtb_career",
            "ВКонтакте": "https://vk.com/vtb_career"
        },
        fontColor: "white",
        isP: true,
        isS: false
    },
    [AppCompaniesChoices["robo-finance"]]: {
        description: "RoboFinance — разработчик международных финтех-продуктов, решений и технологий. Мы ставим масштабные цели, не боимся экспериментов и всегда стремимся к большему. Верим в суперсилу команды и ценим инициативность — поэтому мы про свободную культуру и открытое общение.",
        socials: {
            "Сайт": "https://robo.finance/",
            "Телеграм": "https://t.me/robofinance_team",
            "ВКонтакте": "https://vk.com/robofinance_team"
        },
        fontColor: "black",
        isP: true,
        isS: false
    },
    [AppCompaniesChoices["ar"]]: {
        description: "Ар — агентство HR-маркетинга. Мы помогаем компаниям формировать и развивать бренд работодателя — и влюблять кандидатов в себя. Для этого мы создаём и продвигаем классный контент, запускаем креативные механики, делаем спецпроекты и развиваем SMM.",
        socials: {
            "Сайт": "https://arrr.agency/",
            "Телеграм": "",
            "ВКонтакте": ""
        },
        fontColor: "white",
        isP: false,
        isS: false
    },
    [AppCompaniesChoices["x-5"]]: {
        description: "X5 — лидер технологий в ритейле и один из крупнейших работодателей в стране. Наши процессы выстроены по уникальной бизнес-модели, и мы создаём все условия для роста наших сотрудников: внутри компании 17 разных бизнесов — от торговых сетей до собственной ИТ-компании. В нашей команде атмосфера комьюнити — с лучшими экспертами на рынке, современной корпоративной культурой и реализацией масштабных проектов.",
        socials: {
            "Сайт": "",
            "Телеграм": "https://t.me/insiderx5",
            "ВКонтакте": "https://vk.com/insider_x5"
        },
        fontColor: "white",
        isP: false,
        isS: true
    },
    [AppCompaniesChoices["kontur"]]: {
        description: "Контур — продуктовая экосистема, которой пользуется каждый третий бизнес в России. Мы любим и умеем выстраивать эффективные рабочие процессы в атмосфере комьюнити. С нами ты сможешь по‑настоящему влиять на бизнес-среду, видеть ценность своей работы и достигать амбициозных целей.",
        socials: {
            "Сайт": "https://kontur.ru/",
            "Телеграм": "https://t.me/skbkontur_official",
            "ВКонтакте": "https://vk.com/rabota_v_konture"
        },
        fontColor: "black",
        isP: false,
        isS: false
    }
}

export const getLinkYandexMetrikaCode = (company: keyof typeof AppCompaniesChoices, resource: Socials) => {
    const prefix = `link-${company}`
    switch (resource) {
        case "Сайт":
            return `${prefix}-website`
        case "Телеграм":
            return `${prefix}-telegram`
        case "ВКонтакте":
            return `${prefix}-vk`
    }
}
